export { default } from './ProposedPrincipalAndInterestTooltip';
